"use strict";
import TOPAZ_LOGO from "assets/images/logo.png";
import { EmailLogin } from "components/Web3Provider/privy/EmailLogin";
import { ModalActionButton } from "components/Web3Provider/privy/ModalActionButton";
import { usePrivyAuth } from "components/Web3Provider/privy/PrivyWagmiBridge";
import { useEffect } from "react";
import { ExternalLink } from "theme/components/Links";
import { Flex, ModalCloseIcon, Separator, Text } from "ui/src";
import { Wallet } from "ui/src/components/icons/Wallet";
import { Modal } from "components/modals/Modal";
import { ModalName } from "features/telemetry/constants";
const TOPAZ_ID_URL = "https://id.topazdex.com";
function GoogleIcon() {
  return <svg width={20} height={20} viewBox="0 0 18 18" aria-hidden="true">
      <path
    fill="#4285F4"
    d="M17.64 9.205c0-.639-.057-1.252-.164-1.841H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"
  />
      <path
    fill="#34A853"
    d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.583-5.036-3.71H.957v2.332A8.997 8.997 0 0 0 9 18z"
  />
      <path
    fill="#FBBC05"
    d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.997 8.997 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z"
  />
      <path
    fill="#EA4335"
    d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z"
  />
    </svg>;
}
export function TopazIdModal({
  isOpen,
  onClose,
  onDone
}) {
  const privyAuth = usePrivyAuth();
  const authenticated = privyAuth?.authenticated ?? false;
  const handleDone = () => {
    onClose();
    onDone();
  };
  useEffect(() => {
    if (isOpen && authenticated) {
      onDone();
      onClose();
    }
  }, [isOpen, authenticated, onDone, onClose]);
  return <Modal name={ModalName.TopazId} isModalOpen={isOpen} onClose={onClose} maxWidth={400} padding={0}>
      <Flex p="$spacing20" gap="$gap16">
        <Flex row alignItems="center" justifyContent="space-between">
          <Flex row alignItems="center" gap="$gap8">
            <img src={TOPAZ_LOGO} alt="Topaz" width={24} height={24} style={{ borderRadius: 6, objectFit: "contain" }} />
            <Text variant="subheading1">Topaz ID</Text>
          </Flex>
          <ModalCloseIcon onClose={onClose} />
        </Flex>

        <Text variant="body3" color="$neutral2">
          Sign in with Google, email, or a wallet to access your Topaz ID smart wallet.
        </Text>

        <ModalActionButton
    icon={<GoogleIcon />}
    label={privyAuth?.oauthLoading ? "Redirecting\u2026" : "Continue with Google"}
    disabled={privyAuth?.oauthLoading}
    onPress={() => void privyAuth?.loginWithGoogle().catch(() => {
    })}
  />

        <ModalActionButton
    icon={<Wallet size={20} color="$neutral1" />}
    label="Continue with a wallet"
    onPress={() => privyAuth?.loginWithWallet()}
  />

        <Flex row alignItems="center" gap="$gap12">
          <Separator />
          <Text variant="body4" color="$neutral3">
            or
          </Text>
          <Separator />
        </Flex>

        <EmailLogin onDone={handleDone} />

        <Flex row justifyContent="center" pt="$spacing4">
          <ExternalLink href={TOPAZ_ID_URL} style={{ textDecoration: "none" }}>
            <Text variant="body4" color="$accent1">
              Manage your Topaz ID at id.topazdex.com ↗
            </Text>
          </ExternalLink>
        </Flex>
      </Flex>
    </Modal>;
}
